import Component from "./../../component";

export const CartDrawerCheckoutButtonConfig = {
    signature: 'cartDrawerCheckoutButton',
    baseHtmlClass: 'go-cart__drawer__checkout_button',
    selector: '.go-cart__drawer__checkout_button',
    initedHtmlClassModifier: 'inited',
    disabledHtmlClassModifier: 'disabled',
};

export class CartDrawerCheckoutButton extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerCheckoutButtonConfig
        });

        this.goCart = goCart;

        this.disabled = false;

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.disabled, CartDrawerCheckoutButtonConfig.disabledHtmlClassModifier);
        this.conditionallySetHtmlClassState(this.inited, CartDrawerCheckoutButtonConfig.initedHtmlClassModifier);
    }

}
